/** Tags allowed when rendering stored article HTML. */
export const ARTICLE_HTML_ALLOWED_TAGS = [
  "p",
  "strong",
  "em",
  "h2",
  "h3",
  "ul",
  "ol",
  "li",
  "br",
] as const;
